import { fetchSessionJson } from '../SessionRequest';
import { toRequiredPositiveInteger } from '../Utilities';
import type { ReportDefinition } from '../../types/ReportDefinition';

const API_SERVER = process.env.API_SERVER || '';

export async function getReports(
  subscriptionId: number | string | null | undefined
): Promise<ReportDefinition[]> {
  const validatedSubscriptionId = toRequiredPositiveInteger(subscriptionId, 'subscriptionId');

  return fetchSessionJson<ReportDefinition[]>(
    `${API_SERVER}/subscriptions/admin/subscriptions/${validatedSubscriptionId}/reports`,
    'Failed to fetch subscription reports'
  );
}

const SubscriptionReportService = { getReports };

export default SubscriptionReportService;
